import React from "react";
import styled from "styled-components";

import { RoundBadge } from "@examspark/common-ui/server";
import { TeksCurriculumUsage, TeksCurriculumUsageMeta } from "@examspark/types";

const StyledRoundBadge = styled(RoundBadge)<{ usage: TeksCurriculumUsage }>`
  ${RoundBadge.Circle} {
    color: white;
    background-color: grey;
  }
`;

const ObjectiveCurriculumUsageBadge = (props: {
  value: TeksCurriculumUsage | null | undefined;
  showLabel?: boolean;
}) => {
  if (props.value == null) return null;

  const meta = TeksCurriculumUsageMeta[props.value];

  if (meta == null) return null;

  return (
    <StyledRoundBadge
      usage={props.value}
      letter={meta.abbreviation}
      tooltip={meta.label}
      label={props.showLabel && meta.label}
    />
  );
};

export default ObjectiveCurriculumUsageBadge;
